import React, { useCallback, useEffect, useState } from 'react'
import LayoutWithAccountCard from '../../../../layout/Layout/layout-account-card'
import { DIALOG_KEYS, REQUESTS_KEYS, VALIDATION_MESSAGES } from '../../../../utils/translation-constants'
import { carouselCurrentItemSelector, getFeatureListSelector } from '../../../../selectors'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import RequestService from '../../../../services/requests.service'
import Loading from 'custom/assets/loaders/Loading'
import moment from 'moment'

export default function ChequeBookStatus() {
  const { t } = useTranslation()
  const [dataSource, setDataSource] = useState([])
  const [noRecords, setNoRecords] = useState(false)
  const [loading, setLoading] = useState(false)
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const [expanded, setExpanded] = useState(null)
  const featureList = useSelector(getFeatureListSelector)
  const featureDetails = featureList['CHEQUE_REQ_STATUS']

  useEffect(() => {
    getChequeBookStatus()
  }, [currentAccountDetail])

  const getChequeBookStatus = useCallback(async () => {
    try {
      setLoading(true)
      const response = await RequestService.getChequeBookStatus({
        srcAccount: currentAccountDetail?.accountNo,
        accountBranch: currentAccountDetail?.brnCode,
      })
      if (response.status === 200) {
        setDataSource(response.data['chequeStatusResponseList'])
        setNoRecords(response.data['chequeStatusResponseList'].length > 0 ? false : true)
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [currentAccountDetail])


  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderStatusList() {
    return (
      <>
        {dataSource.map((option, index) => (
          <div key={index} className='loan-card'>
            <div
              className='loan-header '
              onClick={async () => {
                if (expanded == index) {
                  setExpanded(null)
                } else {
                  setExpanded(index)
                }
              }}>
              <div>
                <div className='d-flex'>
                  <label>
                    {t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_STATUS_KEYS.NO_OF_CHEQUE_BOOKS)}
                  </label>
                  <span style={{ marginLeft: 5 }}>{option.noOfChequeBooks}</span>
                </div>
                <div className='d-flex'>
                  <label>
                    {t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_STATUS_KEYS.REQUESTED_DATE)}
                  </label>
                  <span style={{ marginLeft: 5 }}>
                    {moment(option.requestedDate).format('DD/MM/YYYY')}
                  </span>
                </div>
              </div>

              <div>
                <div className='d-flex'>
                  <label>{t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_STATUS_KEYS.STATUS)}</label>
                  <span style={{ marginLeft: 5 }}>
                    {option.status === 'I' && 'Initiated'}
                    {option.status === 'P' && 'Printing'}
                    {option.status === 'R' && 'Ready'}
                    {option.status === 'D' && 'Delivered'}
                    {option.status === 'X' && 'Cancelled'}
                  </span>
                </div>

                <div className='d-flex'>
                  <label>{t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_STATUS_KEYS.BRANCH_CODE)}</label>
                  <span style={{ marginLeft: 5 }}>{option.collectionBranchCode}</span>
                </div>
              </div>
            </div>
            {expanded === index && (
              <div className='loan-details'>
                <div className='row'>
                  <div className='col-4'>
                    <label>
                      {t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_STATUS_KEYS.ACCOUNT_NUMBER)}
                    </label>
                    <span>{option?.accountNo || '-'}</span>
                  </div>
                  <div className='col-4'>
                    <label>{t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_STATUS_KEYS.CURRENCY)}</label>
                    <span>{option?.currency || '-'}</span>
                  </div>
                  <div className='col-4'>
                    <label>
                      {t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_STATUS_KEYS.NO_OF_LEAVES)}
                    </label>
                    <span>{option?.noOfLeaves || '-'}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey='REQUEST_CHEQUE_BOOK_STATUS'>
      <div className='new-design-form-style'>
        <div className='heading-style'>
          {t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_STATUS_KEYS.TITLE)}
        </div>
        <p style={{ fontSize: 11, marginTop: -24, marginBottom: 20 }}>
          {t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_BOOK_STATUS_KEYS.SUBTITLE)}
        </p>
        {loading && renderLoading()}
        {noRecords && <div className='no-data-found'>{t(DIALOG_KEYS.NO_CHEQUE_BOOK_STATUS)}</div>}
        {featureDetails[currentAccountDetail['accountType']] !== 'N' && (
          <div className='new-design-form-style'>
            {dataSource.length > 0 && !loading && renderStatusList()}
          </div>
        )}

        {featureDetails[currentAccountDetail['accountType']] === 'N' && (
          <div className='no-data-found'>{t(VALIDATION_MESSAGES.NO_ACCESS)}</div>
        )}
      </div>
    </LayoutWithAccountCard>
  )
}
